import classes from './pozitivnaProgresija.module.css'
import classesK from '../kalkulatori.module.css'
import { useEffect, useState } from 'react'
import InfoBar from '../redesign/components/InfoBar'
import ResultsSection from '../redesign/components/ResultsSection'
import add from '../images/add.svg'

const PozitivnaProgresija = () => {
  const [showInputArea, setShowInputArea] = useState(true)
  const [data, setData] = useState({
    values: {
      serie1: {
        odd: [''],
        percent: [''],
      },
      stake: [''],
    },
    results: {
      serie1Results: ['-', '-', '-', '-'],
    },
  })

  const clearFields = () => {
    setData({
      values: {
        serie1: {
          odd: [''],
          percent: [''],
        },
        stake: [''],
      },
      results: {
        serie1Results: ['-', '-', '-', '-'],
      },
    })
    setShowInputArea(true)
    setSeries([{ id: 1 }])
  }

  const [series, setSeries] = useState([{ id: 1 }])

  const addSeries = () => {
    setSeries((prevSeries) => {
      const newSeries = [...prevSeries, { id: prevSeries.length + 1 }]
      setData((prevData) => {
        const newSerieKey = `serie${newSeries.length}`
        return {
          ...prevData,
          values: {
            ...prevData.values,
            [newSerieKey]: {
              odd: [0],
              percent: [0],
            },
          },
          results: {
            ...prevData.results,
            [`${newSerieKey}Results`]: prevData.results[
              `${newSerieKey}Results`
            ] || ['-', '-', '-', '-'],
          },
        }
      })
      return newSeries
    })
  }

  useEffect(() => {
    handleCalculateAll()
  }, [data.values])

  const handleCalculateAll = () => {
    setData((prevData) => {
      const updatedData = { ...prevData }
      let currentState = 0
      let previousStake = parseFloat(prevData.values.stake[0]) || 0 // First stake input

      Object.keys(prevData.values).forEach((serieKey) => {
        if (serieKey.startsWith('serie')) {
          const stake = previousStake
          const percent = parseFloat(prevData.values[serieKey]?.percent[0]) || 0
          const odd = parseFloat(prevData.values[serieKey]?.odd[0]) || 1 // Ensure valid odds

          // Calculate Potential Winnings
          const potentialWinnings = stake * odd
          updatedData.results[`${serieKey}Results`] = updatedData.results[
            `${serieKey}Results`
          ] || ['-', '-', '-', '-']
          updatedData.results[`${serieKey}Results`][0] = isNaN(
            potentialWinnings
          )
            ? '-'
            : potentialWinnings.toFixed(2)

          // Calculate Net Profit
          const netProfit = potentialWinnings - stake
          updatedData.results[`${serieKey}Results`][1] = isNaN(netProfit)
            ? '-'
            : netProfit.toFixed(2)

          // Calculate Unit Transfer
          const unitTransfer = netProfit * (percent / 100)
          updatedData.results[`${serieKey}Results`][2] = isNaN(unitTransfer)
            ? '-'
            : unitTransfer.toFixed(2)

          // Update Current State
          console.log(serieKey, netProfit, stake, currentState, previousStake)
          console.log(typeof netProfit, typeof currentState)
          if (serieKey === 'serie1') {
            currentState = netProfit - stake
          } else {
            currentState = parseFloat(netProfit) + parseFloat(currentState)
          }
          console.log(currentState)
          updatedData.results[`${serieKey}Results`][3] = isNaN(currentState)
            ? '-'
            : currentState.toFixed(2)

          // Update the stake for the next series
          previousStake = unitTransfer > 0 ? unitTransfer : previousStake
          console.log('previousStake', previousStake)
        }
      })

      return updatedData
    })
  }
  console.log('data', data)

  return (
    <div className={classesK.container}>
      <InfoBar
        calculatorType={`Pozitivna progresija`}
        onRefresh={clearFields}
      />
      <div className={classesK.contentContainer}>
        {showInputArea && (
          <>
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>Igra</div>
              {series.map((serie) => (
                <div key={serie.id} className={classes.seriesContainer}>
                  <div
                    className={`${classesK.calcButton} ${classes.calcButton}`}
                  >
                    Serija br. {serie.id}
                  </div>
                  <div className={classes.seriesValues}>
                    <div className={classes.oddsContainer}>
                      {serie.id === 1 && (
                        <div className={classesK.oddsContainer}>
                          <span>Upiši ulog</span>
                          <input
                            type='number'
                            min='0'
                            value={data.values.stake[0]}
                            onChange={(e) => {
                              const value = parseFloat(e.target.value)

                              setData((prevData) => ({
                                ...prevData,
                                values: {
                                  ...prevData.values,
                                  stake: [value],
                                },
                              }))
                            }}
                          />
                        </div>
                      )}
                      <div className={classesK.oddsContainer}>
                        <span>Upiši kvotu</span>
                        <input
                          type='number'
                          min='0'
                          value={data?.values[`serie${serie.id}`]?.odd[0] || ''}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value)

                            setData((prevData) => ({
                              ...prevData,
                              values: {
                                ...prevData.values,
                                [`serie${serie.id}`]: {
                                  ...prevData.values[`serie${serie.id}`],
                                  odd: [value],
                                },
                              },
                            }))
                          }}
                        />
                      </div>
                    </div>
                    <ResultsSection
                      names={['Eventualni dobitak', 'Čista dobit']}
                      results={[
                        data?.results[`serie${serie.id}Results`]
                          ? data.results[`serie${serie.id}Results`][0] || '-'
                          : '-',
                        data?.results[`serie${serie.id}Results`]
                          ? data.results[`serie${serie.id}Results`][1] || '-'
                          : '-',
                      ]}
                      allowNegative={true}
                    />
                    <div className={classesK.oddsContainer}>
                      <span>
                        Upiši samo br. procenta prenosa u sl. krug ( % )
                      </span>
                      <input
                        type='number'
                        min='0'
                        value={
                          data?.values[`serie${serie.id}`]?.percent[0] || ''
                        }
                        onChange={(e) => {
                          const value = parseFloat(e.target.value)

                          setData((prevData) => ({
                            ...prevData,
                            values: {
                              ...prevData.values,
                              [`serie${serie.id}`]: {
                                ...prevData.values[`serie${serie.id}`],
                                percent: [value],
                              },
                            },
                          }))
                        }}
                      />
                    </div>

                    <ResultsSection
                      names={['Prenos u valuti', 'Trenutno stanje']}
                      results={[
                        data?.results[`serie${serie.id}Results`]
                          ? data.results[`serie${serie.id}Results`][2]
                          : '-',
                        data?.results[`serie${serie.id}Results`]
                          ? data.results[`serie${serie.id}Results`][3]
                          : '-',
                      ]}
                      allowNegative={true}
                    />
                  </div>
                </div>
              ))}
              {series.length < 25 && (
                <div className={classesK.addMore}>
                  <button onClick={addSeries} className={classesK.addButton}>
                    <img src={add} height={18} width={18} alt='image' />
                    Dodaj još jednu seriju
                  </button>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default PozitivnaProgresija
